import type { ArtistCore } from "./artist";
import type { Currency } from "./currency";
import type { ServiceBase, ServiceEnum } from "./service";

export const MAIN_SUBSCRIPTION_PRODUCT_ID = 1;
export const AYRSHARE_SUBSCRIPTION_PRODUCT_ID = 2;

export enum SubscriptionStatusEnum {
  WaitingForPayment = 0,
  Active = 1,
}

export type SubscriptionPrice = {
  amount: number;
  currency: Currency;
};

export type SubscriptionProductBase = {
  id: number;
  name: string;
  isFeature: boolean;
};

export type SubscriptionProductActive = SubscriptionProductBase & {
  isActive: boolean;
};

export type SubscriptionProduct = SubscriptionProductBase & {
  isBilledMonthly: boolean;
  price: SubscriptionPrice;
};

export type SubscriptionProductPrice = {
  id: number;
  isMonthly: boolean;
  price: SubscriptionPrice;
};

export type ArtistSubscriptionStatus = {
  id: number;
  color: string;
  name: string;
};

export type Subscription = {
  endDate: string | null;
  product: SubscriptionProduct;
  startDate: string | null;
  status: ArtistSubscriptionStatus;
  thankYou: boolean;
  uid: string;
};

export type ArtistSubscription = ArtistCore & {
  subscriptions: Array<Subscription>;
  services: Array<ServiceBase>;
};

export function getIsServiceActive(
  service: ServiceEnum,
  subscription?: {
    active: boolean;
    services?: Array<ServiceBase>;
  } | null,
): boolean {
  return (
    !!subscription?.active &&
    !!subscription.services?.some((s) => s.id === service)
  );
}

export function getIsArtistSubscriptionActive(
  subscription?: ArtistSubscription,
) {
  return (
    !!subscription && subscription.status.id === SubscriptionStatusEnum.Active
  );
}
